// Navbar.js
import React, { useState } from 'react';
import logo from '../images/logo.png'
import './Navbar.css'; 

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            <img className="navbar-brand" src={logo} alt=''></img>
            <div className={`navbar-toggle ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
            <ul className={`navbar-menu ${isOpen ? 'open' : ''}`}>
                <li className="navbar-item"><a href="/">Home</a></li>
                <li className="navbar-item"><a href="#project1">projects</a></li>
                <li className="navbar-item"><a href="#work1">Services</a></li>
                <li className="navbar-item"><a href="#service1">expertise</a></li>
                <li className="navbar-item"><a href="#about1">About</a></li>
            </ul>
        </nav>
    );
};

export default Navbar;
